import { apiSlice } from "../store/api/adminApi"

export type OtpListUser = { id: number, name: string | null, surname: string | null, email: string | null, isDeleted: boolean }

export type StaticOtpItem = {
    id: number
    phone: string
    code: string
    adminUpdatedAt: string | null
    lastLoginDate: string | null
    user: OtpListUser | null
}

export type OtpBypassItem = {
    id: number
    phone: string
    isActive: boolean
    createdAt: string
    user: OtpListUser | null
}

type OtpListQuery = { skip: number, take: number, search?: string }

export const userApi = apiSlice.enhanceEndpoints({ addTagTypes: ['StaticOtp', 'OtpBypass'] }).injectEndpoints({
    endpoints: (build)=>({
        fetchUsers: build.query<any, any>({
            query: (body: {
                type: string, 
                skip: number,
                take: number,
                filter: string
            }) => ({
                url: `/admin/users/list/${body.type}?skip=${body.skip || 0}&take=${body.take || 10}${body.filter || ""}`
            }),
        }),
        getUser: build.query<any, string>({
            query: (id: string) => ({
                url: `/admin/users/${id}`
            })
        }),
        deleteUser: build.mutation({
            query: (id: string | number) => ({
                url: `/admin/users/${id}`,
                method: 'DELETE',
            }),
        }),
        restoreUser: build.mutation({
            query: (id: string | number) => ({
                url: `/admin/users/restore/${id}`,
                method: 'PUT',
            }),
        }),
        autoConfirmation: build.mutation({
            query: (id: string | number) => ({
                url: `/admin/users/auto-confirmation/${id}`,
                method: 'PUT',
            }),
        }),
        getRobotSmsTotalCredits: build.query({
            query: () => ({
                url: `/admin/users/robot-sms/credits/total`,
                method: 'GET',
            }),
        }),
        updateRobotSmsAccess: build.mutation({
            query: ({ id, isCanUseRobotSms }: { id: string | number, isCanUseRobotSms: boolean }) => ({
                url: `/admin/users/${id}/robot-sms/access`,
                method: 'PUT',
                body: {
                    isCanUseRobotSms,
                }
            }),
        }),
        updateRobotSmsCredits: build.mutation({
            query: ({ id, robotSmsCredits }: { id: string | number, robotSmsCredits: number }) => ({
                url: `/admin/users/${id}/robot-sms/credits`,
                method: 'PUT',
                body: {
                    robotSmsCredits,
                }
            }),
        }),
        openUserAsAdmin: build.query<{}, {id: number}>({
            query: ({id}) => ({
                  url: `/admin/open/user/${id}`
            }),
        }),
        sendOtp: build.mutation({
            query: (body: { phone: string, otp: string, isStatic: boolean }) => ({
                url: `/admin/users/opt/generate`,
                method: 'POST',
                body: {
                    phone: `+${body.phone}`,
                    otp: body.otp,
                    isStatic: body.isStatic
                }
            }),
            invalidatesTags: ['StaticOtp'],
        }),
        getStaticOtpList: build.query<{ list: StaticOtpItem[], count: number }, OtpListQuery>({
            query: ({ skip, take, search }) => ({
                url: `/admin/users/otp/static`,
                params: { skip, take, ...(search ? { search } : {}) },
            }),
            providesTags: ['StaticOtp'],
        }),
        removeStaticOtp: build.mutation({
            query: (id: number) => ({
                url: `/admin/users/otp/static/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['StaticOtp'],
        }),
        getOtpBypassList: build.query<{ list: OtpBypassItem[], count: number }, OtpListQuery>({
            query: ({ skip, take, search }) => ({
                url: `/admin/users/otp/bypass`,
                params: { skip, take, ...(search ? { search } : {}) },
            }),
            providesTags: ['OtpBypass'],
        }),
        addOtpBypassPhone: build.mutation({
            query: (phone: string) => ({
                url: `/admin/users/otp/bypass`,
                method: 'POST',
                body: { phone: `+${phone}` },
            }),
            invalidatesTags: ['OtpBypass'],
        }),
        setOtpBypassActive: build.mutation({
            query: ({ id, isActive }: { id: number, isActive: boolean }) => ({
                url: `/admin/users/otp/bypass/${id}`,
                method: 'PUT',
                body: { isActive },
            }),
            invalidatesTags: ['OtpBypass'],
        }),
        removeOtpBypassPhone: build.mutation({
            query: (id: number) => ({
                url: `/admin/users/otp/bypass/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ['OtpBypass'],
        }),
    })
})